import React from 'react'
import { Route, Routes } from 'react-router-dom'
import HomePage from '../../components/pages/HomePage/HomePage'
import AboutUsPage from '../../components/pages/AboutUs/AboutUsPage'
import Layout from './layout'
import RabbitXPage from '../../components/pages/RabbitXPage/RabbitXPage'
import CryptonaryPage from '../../components/pages/CryptonaryPage/CryptonaryPage'
import ArbVenturePage from '../../components/pages/ArbVenturePage/ArbVenturePage'
import PortfolioProjectPage from '../../components/pages/PortfolioProjectPage/PortfolioProjectPage'
import ProtfolioPage from '../../components/pages/ProtfolioPage/ProtfolioPage'
import IndustryPage from '../../components/pages/IndustryPage/IndustryPage'
import TechnologyPage from '../../components/pages/TechnologyPage/TechnologyPage'
import FrontendPage from '../../components/pages/FrontendPage/FrontendPage'
import BackendPage from '../../components/pages/BackendPage/BackendPage'
import DatabasePage from '../../components/pages/DatabasePage/DatabasePage'
import CloudDevopsPage from '../../components/pages/CloudDevopsPage/CloudDevopsPage'
import AutomationPage from '../../components/pages/AutomationPage/AutomationPage'
import BlogPage from '../../components/pages/BlogPage/BlogPage'
import BlogDetailsPage from '../../components/pages/BlogDetailsPage/BlogDetailsPage'
import ContactUsPage from '../../components/pages/ContactUsPage/ContactUsPage'
import CareerPage from '../../components/pages/CareerPage/CareerPage'
import GalleryPage from '../../components/pages/GalleryPage/GalleryPage'
import IndustryFintechPage from '../../components/pages/IndustryFintechPage/IndustryFintechPage'
import IndustryHealthcarePage from '../../components/pages/IndustryHealthcarePage/IndustryHealthcarePage'
import DDXPage from '../../components/pages/DDXPage/DDXPage'
import UpskillPage from '../../components/pages/UpskillPage/UpskillPage'
import Medilearn from '../../components/pages/Medilearn/Medilearn'

import ServicePage from '../../components/pages/ServicePage/ServicePage'
import TatvaCarePage from '../../components/pages/TatvaCarePage/TatvaCarePage'



const AppRoutes = () => {
    return (
        <div>
            <div>
                <Routes>
                    <Route path="/" element={<Layout />} >
                        <Route path="" element={<HomePage />} />
                        <Route path="aboutus" element={<AboutUsPage />} />
                        <Route path="portfolio/rabbitx" element={<RabbitXPage />} />
                        <Route path="portfolio/cryptonary" element={<CryptonaryPage />} />

                        <Route path="portfolio/gostor" element={<PortfolioProjectPage />} />
                        <Route path="portfolio/Medilearn" element={<Medilearn />} />
                        
                        <Route path="portfolio/tatvacare" element={<TatvaCarePage />} />
                        <Route path="portfolio/arbventure" element={<ArbVenturePage />} />
                        <Route path="portfolio/ddx" element={<DDXPage />} />
                        <Route path="portfolio/project" element={<PortfolioProjectPage />} />
                        <Route path="portfolio" element={<ProtfolioPage />} />
                        <Route path="industry" element={<IndustryPage />} />
                        <Route path="industryfintech" element={<IndustryFintechPage />} />
                        <Route path="industryhealthcare" element={<IndustryHealthcarePage />} />
                        <Route path="technology" element={<TechnologyPage />} />
                        <Route path="frontend" element={<FrontendPage />} />
                        <Route path="backend" element={<BackendPage />} />
                        <Route path="database" element={<DatabasePage />} />
                        <Route path="clouddevops" element={<CloudDevopsPage />} />
                        <Route path="automation" element={<AutomationPage />} />
                        <Route path="service" element={<ServicePage />} /> 
                        <Route path="blog" element={<BlogPage />} />
                        <Route path="blogdetails/:slug" element={<BlogDetailsPage />} />
                        <Route path="contactus" element={<ContactUsPage />} />
                        <Route path="career" element={<CareerPage />} />
                     
                        <Route path="gallery" element={<GalleryPage />} />
                        <Route path="upskill" element={<UpskillPage />} />


                    </Route>
                </Routes>
            </div>
        </div>
    )
}

export default AppRoutes
